import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as add } from './configurations/add';
import { apiAction as deleteExternalCpd } from './configurations/deleteExternalCpd';
import { apiAction as get } from './configurations/get';
import { apiAction as update } from './configurations/update';

export const apiActions = {
  externalCpd: {
    get,
    add,
    update,
    deleteExternalCpd
  }
}

const actions = mapActionsFromConfigurations('externalCpd')(configurations);

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/actions.js